import { createCRUDSlice } from "../crudSliceFactory";
const { actions, reducer, selectors } = createCRUDSlice("commercialInvoices", "/commercial-invoices");
export const { fetchAll: fetchCommercialInvoices, fetchOne: fetchOneCommercialInvoices, createOne: createCommercialInvoices, updateOne: updateCommercialInvoices, deleteOne: deleteCommercialInvoices } = actions;
export const { selectList, selectSelected, selectLoading, selectSubmitting, selectError, selectPagination } = selectors;
export default reducer;
